export const RESEND_ACTIVATE_LINK_REQUEST = 'RESEND_ACTIVATE_LINK_REQUEST';

export const resendActivateLinkRequest = ( id ) => ({
    type: RESEND_ACTIVATE_LINK_REQUEST,
    payload: {
        id,
    }
});
